import { createClient } from '@supabase/supabase-js';

// Production defaults - app works without .env in production
const PROD_SUPABASE_URL = "https://api.obha.sa";
const PROD_SUPABASE_ANON_KEY = "sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || PROD_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || PROD_SUPABASE_ANON_KEY;

// Warn if using production credentials in development
if (import.meta.env.DEV && SUPABASE_URL === PROD_SUPABASE_URL) {
  console.warn(
    "⚠️ Using PRODUCTION Supabase credentials in development.\n" +
    "Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env for local development."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
